import React from 'react';
import { useParams } from 'react-router-dom';
import { translate } from '../utils/translator';
import RegretBannerRight from '../icons/RegretBannerRight.svg';
import RegretBannerLeft from '../icons/RegretBannerLeft.svg';

interface RxUpsellRegretBannerProps {
  onUpgradeClick: () => void;
  onDismiss: () => void;
  country?: string;
}

const TITLE_HIGHLIGHT_CLASS: Record<string, string> = {
  fr: 'text-[17px] md:text-[22px]',
};

const RxUpsellRegretBanner: React.FC<RxUpsellRegretBannerProps> = ({ onUpgradeClick, onDismiss, country }) => {
  const { language } = useParams<{ language: string }>();
  const t = (key: string) => translate(language, 'shipping', `RxUpsellRegretBanner/${key}`) as string;
  const titleHighlightClass = (country && TITLE_HIGHLIGHT_CLASS[country]) || 'text-[21px] md:text-[26px]';

  return (
    <div className="w-full mb-4">
      <div className="rounded-[6px] overflow-hidden relative w-full rx-regret-banner-bg">
        {/* Right decorative SVG */}
        <div className="absolute pointer-events-none -right-[43px] -top-[13px] w-[221px] h-[152px] flex items-center justify-center">
          <img src={RegretBannerRight} alt="" className="rotate-[24.38deg]" />
        </div>

        {/* Left decorative SVG */}
        <div className="absolute pointer-events-none -left-[112px] -top-[9px] w-[230px] h-[151px] flex items-center justify-center">
          <img src={RegretBannerLeft} alt="" className="rotate-[157.14deg] scale-y-[-1]" />
        </div>

        {/* Content */}
        <div className="relative z-10 flex items-center justify-between px-4 py-4 md:px-5 md:py-5">
          <div className="flex flex-col gap-[4px] flex-1 min-w-0 mr-3">
            <p className="font-poppins font-bold leading-[1.15]">
              <span className="text-white block text-[17px] md:text-[20px]">{t('titlePrefix')}</span>
              <span className={`block text-[#d9ff00] ${titleHighlightClass}`}>{t('titleHighlight')}</span>
            </p>
            <p className="leading-[1.15]">
              <span className="font-roboto font-semibold text-white text-[15px] md:text-[17px]">{t('subtitleBold')}</span>
              {' '}
              <span className="font-roboto text-[13px] md:text-[14px] text-white/90">{t('subtitleSuffix')}</span>
            </p>
          </div>
          <button
            onClick={onUpgradeClick}
            className="bg-white h-[42px] md:h-[52px] rounded-[5px] flex-shrink-0 cursor-pointer border-0 flex items-center justify-center px-4 md:px-5"
          >
            <span className="font-roboto font-medium text-[14px] md:text-[17px] whitespace-nowrap linear-text-color-primary">
              {t('cta')}
            </span>
          </button>
        </div>
      </div>

      {/* Dismiss link */}
      <div className="text-center mt-2">
        <button
          onClick={onDismiss}
          className="font-roboto font-medium text-[13px] text-[#686876] underline border-0 bg-transparent outline-none cursor-pointer"
        >
          {t('dismiss')}
        </button>
      </div>
    </div>
  );
};

export default RxUpsellRegretBanner;
